'use client'

import {useEffect, useState} from 'react'
import {breakpoints} from '../lib/utils'

interface ResponsiveState {
    isMobile: boolean
    isTablet: boolean
    isDesktop: boolean
    width: number
    breakpoint: 'mobile' | 'tablet' | 'desktop'
}

export const useResponsive = (): ResponsiveState => {
    const [state, setState] = useState<ResponsiveState>(() => ({
        isMobile: true,
        isTablet: false,
        isDesktop: false,
        width: 0,
        breakpoint: 'mobile'
    }))

    useEffect(() => {
        if (typeof window === 'undefined') {
            return
        }

        const resolveState = (): ResponsiveState => {
            const width = window.innerWidth
            return {
                isMobile: width < breakpoints.tablet,
                isTablet: width >= breakpoints.tablet && width < breakpoints.desktop,
                isDesktop: width >= breakpoints.desktop,
                width,
                breakpoint: width < breakpoints.tablet ? 'mobile' : width < breakpoints.desktop ? 'tablet' : 'desktop'
            }
        }

        setState(resolveState())

        const handleResize = () => {
            setState(resolveState())
        }

        let timeoutId: NodeJS.Timeout
        const debouncedResize = () => {
            clearTimeout(timeoutId)
            timeoutId = setTimeout(handleResize, 150)
        }

        window.addEventListener('resize', debouncedResize, {passive: true})
        handleResize()

        return () => {
            window.removeEventListener('resize', debouncedResize)
            clearTimeout(timeoutId)
        }
    }, [])

    return state
}
